import * as config from './uiConfig';
import uiConfig from 'src/lib/ui/config';
import { SelectionalScript } from 'src/replicant/conversation/conservation.ruleset';
import { Widen } from 'src/replicant/utils/types';
import StateObserver from 'src/StateObserver';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { Conversation } from 'src/replicant/conversation';
import sounds from 'src/lib/sounds';
import PopupSpeechBubbleBase, {
  SpeechBubbleCloseHandler,
} from './PopupSpeechBubbleBase';
import { animate, View } from '@play-co/timestep-core/ui';
import platform from '@play-co/gcinstant';
import { getPlayerIdFromConversation } from 'src/game/conversation/conversation.redux';

export default class PopupSelectionalScript extends PopupSpeechBubbleBase<number> {
  private options: ButtonScaleViewWithText[];

  constructor(opts: {
    superview: View;
    close: SpeechBubbleCloseHandler<number>;
  }) {
    super({ ...opts, $subFeature: 'selectional' });
  }

  init(script: SelectionalScript) {
    const { user, ui, conversation } = StateObserver.getState();

    super.init({
      id: script.id,
      move_to: script.move_to,
      message: Conversation.getters(user).getScriptText(
        script.id,
        ui.locale,
        getPlayerIdFromConversation(script.id) !== platform.playerID,
      ),
    });

    this.options = this.getOptions(script).map((option, i) => {
      const button = new ButtonScaleViewWithText({
        ...uiConfig.buttons.primary,
        width: 400,
        height: 90,
        centerOnOrigin: true,
        x: this.box.style.width / 2,
        y: 550 + 102 * i,
        font: 'Body',
        fontSize: 32,
        localeText: () => option,
        onClick: async () => {
          sounds.sfx.play('ok');
          this.opts.close(i + 1);
        },
        tracking: { feature: 'conversation-answer', $subFeature: `${i}` },
        opacity: 0,
        scaleX: 0.9,
        scaleY: 0.9,
      });
      button.setDisabled(true);
      this.box.addSubview(button);

      return button;
    });
  }

  private getOptions(script: SelectionalScript) {
    const options: string[] = [];
    const localeSuffix =
      StateObserver.getState().ui.locale === 'en' ? 'en' : 'jp';
    for (let i = 1; i <= 5; ++i) {
      const prop = `option_${i}_${localeSuffix}`;
      if (script[prop]) {
        options.push(script[prop]);
      }
    }
    return options;
  }

  public fadeIn() {
    super.fadeIn();

    this.currentAnimation.then(() => {
      this.options.forEach((option, i) =>
        animate(option)
          .wait(i * 50)
          .then({ opacity: 1, scaleX: 1, scaleY: 1 }, 100)
          .then(() => option.setDisabled(false)),
      );
    });
  }
}
